import { PrismicRichText } from '@prismicio/react';
import ContentContainer from 'remote-com-shared/components/ContentContainer';
import { fluidProp, whenProp } from 'remote-com-shared/style/helpers';
import styled, { css } from 'styled-components';

import {
  Title as TitleComponent,
  Description as DescriptionComponent,
  BaseLinkStyle,
} from './ContentSlice';
import LeftLeaves from './assets/left-leaves.svg';
import RightLeaves from './assets/right-leaves.svg';

import { fieldHasContent, transformProperties } from '@/src/domains/prismic/helpers';
import { defaultPrismicComponents } from '@/src/domains/prismic/render';

const Section = styled.section`
  ${fluidProp(['padding-top', 'padding-bottom'], '70px', '120px')}
  font-family: var(--typography-fontBrand);
  background-color: #fafafa;
  position: relative;
  box-sizing: border-box;

  ${whenProp(
    '$reducePadding',
    css`
      ${fluidProp('padding-bottom', '20px', '50px')};
      ${fluidProp('padding-top', '40px', '80px')};
    `
  )}
`;

export const Description = styled(DescriptionComponent)`
  padding: 0;
  z-index: 1;
  position: relative;
  ${BaseLinkStyle}

  p {
    margin: 0 0 30px;
  }

  ul,
  ol {
    margin: 30px 0;
  }
`;

export const Title = styled(TitleComponent)`
  ${({ theme }) => theme.typography.scale4}
  z-index: 1;
  position: relative;
  padding-bottom: 30px;
`;

const LeftBg = styled.div`
  position: absolute;
  bottom: -15px;
  left: 0;
  z-index: 0;
`;

const RightBg = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 0;
`;

export function FlexibleSupplementalSlice({ slice }) {
  const { primary } = transformProperties(slice);
  const { title, description, removeImage, sectionId } = primary;

  return (
    <Section id={sectionId} $reducePadding={removeImage}>
      <ContentContainer>
        {fieldHasContent(title) && (
          <Title>
            <PrismicRichText field={title} />
          </Title>
        )}
        {fieldHasContent(description) && (
          <Description>
            <PrismicRichText field={description} components={defaultPrismicComponents} />
          </Description>
        )}
      </ContentContainer>
      {!removeImage && (
        <>
          <LeftBg>
            <LeftLeaves />
          </LeftBg>
          <RightBg>
            <RightLeaves />
          </RightBg>
        </>
      )}
    </Section>
  );
}
